// Matriz de permissões por perfil de acesso.
// Fonte única de verdade no front-end para esconder/mostrar ações na UI.
// IMPORTANTE: isto é apenas UX. A segurança de fato é validada pelo back-end.
//
// PERFIL         VER    ENVIAR/CRIAR   EDITAR   DELETAR   ADMINISTRAR CONTA
// Admin          SIM    SIM            SIM      SIM       SIM
// Contributor    SIM    SIM            SIM      SIM       NAO
// Editor         SIM    SIM            SIM      NAO       NAO
// Viewer         SIM    NAO            NAO      NAO       NAO

export const ROLE_PERMISSIONS = {
    admin: { view: true, create: true, edit: true, delete: true, admin: true },
    contributor: { view: true, create: true, edit: true, delete: true, admin: false },
    editor: { view: true, create: true, edit: true, delete: false, admin: false },
    viewer: { view: true, create: false, edit: false, delete: false, admin: false },
};

export const ROLE_LABELS = {
    admin: 'Administrador',
    contributor: 'Colaborador',
    editor: 'Editor',
    viewer: 'Visualizador',
};

export const ROLE_DESCRIPTIONS = {
    admin: 'Acesso completo. Gerencia o conteúdo e também a equipe — convida usuários, define o que cada um pode fazer e ajusta as configurações da conta.',
    contributor: 'Gerencia totalmente o conteúdo — pode enviar, editar e excluir vídeos e materiais. Não gerencia usuários nem configurações da conta.',
    editor: 'Envia e edita conteúdo, mas não pode excluir. Perfil seguro para quem produz material sem risco de apagar vídeos.',
    viewer: 'Acesso somente para visualização. Pode assistir e navegar pelo conteúdo, mas não altera nada.',
};

// Normaliza o nome do perfil (aceita "Admin", "admin", etc.)
function normalizeRole(roleName) {
    return (roleName || '').toString().trim().toLowerCase();
}

export function roleLabel(roleName) {
    const key = normalizeRole(roleName);
    return ROLE_LABELS[key] || roleName || '';
}

export function roleDescription(roleName) {
    return ROLE_DESCRIPTIONS[normalizeRole(roleName)] || '';
}

// Retorna o objeto de permissões do perfil. Default = Viewer (mais restritivo)
// para que, em caso de role desconhecida, a UI não exponha ações indevidas.
export function permissionsFor(roleName) {
    return ROLE_PERMISSIONS[normalizeRole(roleName)] || ROLE_PERMISSIONS.viewer;
}

// Checagem pontual de uma ação: can(roleName, 'delete')
export function can(roleName, action) {
    return !!permissionsFor(roleName)[action];
}
